import { httpClient } from './http-client';
import type { ApiContactRequest, ApiContact } from '@/types/api.types';

class ContactService {
  /**
   * Submit a contact form inquiry
   */
  async submitContact(data: ApiContactRequest): Promise<ApiContact> {
    return httpClient.post<ApiContact>('/api/v1/inquiries', data);
  }
}

export const contactService = new ContactService();
